import { useState } from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'
import { ProductUpdatesMedia } from 'generated/resources/graphql'

import ClickableMedia from 'modules/product_updates/components/ClickableMedia'

type MediaProps = {
  id: string
  media?: ProductUpdatesMedia[] | undefined | null
  slug: string
  thumbnail: { src: string }
  autoplay: boolean
}

const Media = ({ media, slug, thumbnail, autoplay }: MediaProps) => {
  const [isHovered, setIsHovered] = useState(false)

  const productUpdateMedia = (): { alt: string; url: string; video?: boolean }[] => {
    return (
      media?.map((item) => {
        const imgObj = {
          url: item.video?.mp4Url || item.url || '',
          alt: '',
          video: !!item.video?.mp4Url || item.url?.includes('.mp4'),
        }
        return imgObj
      }) || []
    )
  }

  const [video] = productUpdateMedia()

  return (
    <ClickableMedia
      src={!!video ? video.url : thumbnail?.src}
      video={!!video}
      productUpdateSlug={slug}
      openDialog={autoplay}
    >
      <Box
        borderRadius={{ all: 'abs016' }}
        overflowX="hidden"
        alignSelf="center"
        position="relative"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {video && isHovered ? (
          <>
            {!autoplay && <Icon.Medium icon="play-filled" />}
            <video
              src={video?.url || ''}
              title={video?.alt || ''}
              autoPlay={autoplay}
              loop
              muted
              controls={!autoplay}
            />
          </>
        ) : (
          <img src={thumbnail?.src || ''} />
        )}
      </Box>
    </ClickableMedia>
  )
}

export default Media
